import axios from '../axios-on-rails';

import "core-js/stable";
import "regenerator-runtime/runtime";

class MemberJobFolders {
  constructor() {
    this.debounceCheckAllMember = this.debounce(this.ajaxCheckAllMember.bind(this));
    this.debounceCheckSingleMember = this.debounce(this.ajaxCheckSingleMember.bind(this));
    this.debounceIgnoreAllMember = this.debounce(this.ajaxIgnoreAllMember.bind(this));
  }

  getSearchSessionId(){
    const url = new URLSearchParams(window.location.search);
    return url.get('searchsession');
  }

  toggleIgnore(target, isDisplayIgnored = true, resumeSearchResultId = '') {
    var member_id        = $(target).attr('id').split('_')[1];
    var btn              = $(target);
    var container        = $('#member_' + member_id);
    var ignore;
    if ($(target).hasClass('not_ignored_btn')){
      ignore = 'true';
    } else {
      ignore = 'false';
    }

    axios({
      method: 'put',
      url:  Routes.scouts_ignore_path(gon.locale, member_id),
      data: {
        ignore_member: {
          ignore: ignore,
          resume_search_result_id: resumeSearchResultId
        }
      }
    }).then((res) => {
      if (res.status == 200) {
        if (isDisplayIgnored) {
          this.changeIconIgnored(btn);
        } else {
          this.removeElementIgnored(container);
        }
      }
    })
  }

  debounce(func, delay = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  ajaxCheckSingleMember(memberId, checked, display_ignored) {
    axios({
      method: 'delete',
      url:  Routes.member_job_folders_checkbox_path(gon.locale, memberId),
      data: {
        member_id: memberId,
        checked: checked,
        display_ignored: display_ignored,
        searchsession: this.getSearchSessionId()
      }
    }).then((res) => {
      if (res.status == 200) {
        $('.js-checkbox-all').prop('checked', res.data.is_all_members_checked);
      }
    })
  }

  checkboxOne(target, display_ignored){
    let memberId = $(target).val();
    let checked = $(target).prop("checked");
    let totalMemberSelected = parseInt($('[data-target="memberCount"]').text());
    totalMemberSelected = checked ? (totalMemberSelected + 1) : (totalMemberSelected - 1);
    this.showHideNotice(totalMemberSelected);
    this.debounceCheckSingleMember(memberId, checked, display_ignored);
  }

  ajaxCheckAllMember(checked, display_ignored) {
    axios({
      method: 'post',
      url:  Routes.member_job_folders_checkboxes_path(gon.locale),
      data: {
        checked: checked,
        display_ignored: display_ignored,
        searchsession: this.getSearchSessionId()
      }
    }).then(({ data, status }) => {
      if (status == 200) {
        $('input.js-checkbox-all').prop('checked', checked);
        $('input.js-checkbox-jobfolder').prop('checked', checked);
        this.showHideNotice(data.total_member_checked);
      }
    })
  }

  checkboxAll(target, display_ignored){
    let checked = $(target).prop('checked');
    this.debounceCheckAllMember(checked, display_ignored);
  }

  showHideNotice(num) {
    let noticeElement = $('[data-target="notice"]');
    let memberCountElement = noticeElement.find('[data-target="memberCount"]');
    let scoutAvailable = memberCountElement.data('available');

    if (num > scoutAvailable) {
      noticeElement.addClass('alert alert-danger');
      $('[data-btn="sendAll"]').addClass('disabled');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      noticeElement.removeClass('alert alert-danger');
      $('[data-btn="sendAll"]').removeClass('disabled');
    }
    memberCountElement.text(num);
  }

  ajaxIgnoreAllMember(data, searchParams, memberIds, allChecked, isDisplayIgnored, formEle) {
    axios({
      method: 'POST',
      url:  Routes.scouts_ignore_index_path(gon.locale),
      data: {
        member_ids: memberIds,
        searchsession: searchParams.get('searchsession'),
        all_checked: allChecked,
        screen: data.screen,
        resume_search_result_id: data.resume_search_result_id,
        display_ignored: searchParams.get('display_ignored'),
        result_id: searchParams.get('result_id')
      }
    }).then((res) => {
      if (res.status == 200) {
        if (isDisplayIgnored == 'true' || typeof(isDisplayIgnored) === 'undefined') {
          this.changeIconIgnoredAll();
        } else {
          // Reload page for update results
          // Case: @resume_search.ignored
          location.reload();
        }
      }
    })
  }

  ignoreAll(btnElement, data = {}) {
    let formEle          = $(btnElement).closest('form');
    let memberIds        = [];
    let isDisplayIgnored = $('#js-display-ignored').val();
    let allChecked       = $('input.js-checkbox-all').prop('checked');
    let searchParams     = new URLSearchParams(window.location.search);

    if (formEle.length == 0) formEle = $('#members');

    formEle.find('input.js-checkbox-jobfolder:checked').each(function() {
      memberIds.push($(this).val());
    });

    if (memberIds.length === 0 && gon.hasOwnProperty('alert_text')) return alert(gon.alert_text);

    formEle.find('input.js-checkbox-jobfolder').prop('checked', false);
    $('input.js-checkbox-all').prop('checked', false);
    this.showHideNotice(0);
    this.debounceIgnoreAllMember(data, searchParams, memberIds, allChecked, isDisplayIgnored);
  }

  changeIconIgnoredAll(){
    $.each($("input.js-checkbox-jobfolder:checked"), (i, ele) => {
      var trElement = $(ele).closest('tr');
      trElement.find('.not_ignored_btn,.ignored_btn').addClass('ignored_btn').removeClass('not_ignored_btn');
      trElement.find('i').addClass('fa-eye-slash').removeClass('fa-eye');
      this.changeTitleText(trElement.find('span'));
    });
  }

  changeIconIgnored(element) {
    element.toggleClass('ignored_btn not_ignored_btn');
    element.find('i').toggleClass('fa-eye-slash fa-eye');
    this.changeTitleText(element);
  }

  changeTitleText(element){
    if(!gon.hasOwnProperty('title_ignored_btn') || !gon.hasOwnProperty('title_not_ignored_btn')){
      return;
    }
    var ignored = !element.hasClass('not_ignored_btn');
    element.attr('title', ignored ? gon.title_ignored_btn : gon.title_not_ignored_btn);
  }

  removeElementIgnored(element) {
    element.hide(1000);
    // Decrement count display at screen resume_search_results
    if ($('.jsResultMemberCount')) {
      $('.jsResultMemberCount').textContent = parseInt($('.jsResultMemberCount').textContent) - 1;
    }
  }
}
export default new MemberJobFolders();
